export default __webpack_public_path__ + "static/media/4.80a3066a.webp";